export interface ContextoEmbed {
  embedded: boolean;
  embedOrigin?: string;
}

export function detectarContextoEmbed(): ContextoEmbed {
  try {
    if (window.self === window.top) {
      return { embedded: false };
    }
  } catch {
    return { embedded: true };
  }

  let embedOrigin: string | undefined;
  try {
    const ancestors = (window.location as { ancestorOrigins?: DOMStringList })
      .ancestorOrigins;
    if (ancestors && ancestors.length > 0) {
      embedOrigin = ancestors[0];
    } else if (document.referrer) {
      embedOrigin = new URL(document.referrer).origin;
    }
  } catch {
    embedOrigin = undefined;
  }

  return { embedded: true, embedOrigin };
}
